import commonService from "../../../services/Common/service";
import { CommonActionTypes } from "../../action-types";


export const fetchSumsubToken = (data) => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const res = await commonService.post("/user/get-sumsub-token", data);

    return res.data;
  } catch (err) {
    const errorData = err?.response?.data;
    const message = errorData?.message || err.message;

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
    return errorData || { success: false, message: "Network Error" };
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};
